"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToTwoDecimals = exports.applyOpacity = exports.extractOpacity = exports.convertColorToRGBAUnits = exports.convertRGBAorRGBToRGBAUnits = exports.convertHexaOrHexToRGBAUnits = exports.convertHexUnitTo256 = exports.getChannelsFromHex = void 0;
const colorAssertions_1 = require("./colorAssertions");
const colorKeywords_1 = require("./colorKeywords");
const getChannelsFromHex = (color) => {
    const chunkSize = Math.floor((color.length - 1) / 3);
    return color
        .slice(1)
        .match(new RegExp(`.{${chunkSize}}`, 'g'));
};
exports.getChannelsFromHex = getChannelsFromHex;
const convertHexUnitTo256 = (hex) => parseInt(hex.repeat(2 / hex.length), 16);
exports.convertHexUnitTo256 = convertHexUnitTo256;
const convertHexaOrHexToRGBAUnits = (color) => {
    if (!(0, colorAssertions_1.isValidHexaOrHex)(color)) {
        return;
    }
    const hexArr = (0, exports.getChannelsFromHex)(color);
    const [r, g, b, a] = hexArr.map(exports.convertHexUnitTo256);
    const alpha = typeof a !== 'undefined' ? (0, exports.roundToTwoDecimals)(a / 255) : 1;
    return [r, g, b, alpha];
};
exports.convertHexaOrHexToRGBAUnits = convertHexaOrHexToRGBAUnits;
const convertRGBAorRGBToRGBAUnits = (color) => {
    if (!(0, colorAssertions_1.isValidRGBOrRGBA)(color)) {
        return;
    }
    const inParts = color.substring(color.indexOf('(')).split(',');
    const r = parseInt(inParts[0].substring(1).trim(), 10);
    const g = parseInt(inParts[1].trim(), 10);
    const b = parseInt(inParts[2].trim(), 10);
    const a = inParts[3] &&
        parseFloat(inParts[3].substring(0, inParts[3].length - 1).trim());
    const alpha = typeof a !== 'undefined' ? a : 1;
    return [r, g, b, alpha];
};
exports.convertRGBAorRGBToRGBAUnits = convertRGBAorRGBToRGBAUnits;
const convertColorToRGBAUnits = (color) => (0, colorAssertions_1.isValidHexaOrHex)(color)
    ? (0, exports.convertHexaOrHexToRGBAUnits)(color)
    : (0, colorAssertions_1.isValidRGBOrRGBA)(color)
        ? (0, exports.convertRGBAorRGBToRGBAUnits)(color)
        : (0, colorAssertions_1.isKeyword)(color)
            ? (0, exports.convertHexaOrHexToRGBAUnits)(colorKeywords_1.colorKeywords[color])
            : undefined;
exports.convertColorToRGBAUnits = convertColorToRGBAUnits;
const extractOpacity = (color) => {
    const colorUnits = (0, exports.convertColorToRGBAUnits)(color);
    if (colorUnits) {
        return colorUnits[3];
    }
    return;
};
exports.extractOpacity = extractOpacity;
const applyOpacity = (color, opacity) => {
    const colorUnits = (0, exports.convertColorToRGBAUnits)(color);
    if (colorUnits) {
        const [r, g, b] = colorUnits;
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    return;
};
exports.applyOpacity = applyOpacity;
const roundToTwoDecimals = (number) => Math.round(number * 1e2) / 1e2;
exports.roundToTwoDecimals = roundToTwoDecimals;
//# sourceMappingURL=colorTransformations.js.map